var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarEventFill = function SvgCalendarEventFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 3.9h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9H8V2.1h1.8v1.8h5.4V2.1H17zM5.3 9.3v9h14.4v-9zm1.8 3.6h4.5v3.6H7.1z"
  })));
};
export default SvgCalendarEventFill;